import BookmarkedRecipe from "../components/Bookmarks/BookmarkedRecipe";

const BoomarkedRecipePage = (): JSX.Element => {
  return <BookmarkedRecipe />;
};

export default BoomarkedRecipePage;
